export class Client  {
  id?:number;
  rut:string;
  name:string;
  email:string;
  address:string;
  contact:string;
  phone: string;
  country:number

  constructor(id , rut, name, email, address, contact, phone, country ){
    this.id = id;
    this.rut = rut;
    this.name = name;
    this.email = email;
    this.address = address;
    this.contact = contact;
    this.phone = phone;
    this.country = country;
  }


  public getJson(){
    let nul1 = '';
    let nul2 = '';
    let nul3 = '';
    let nul4 = '';

    if(this.rut != '' && this.rut != null){
      nul1 = `"rut": "${this.rut}",`;
    }
    if(this.email != '' && this.email != null){
      nul2 = `"email": "${this.email}",`;
    }
    if(this.phone != '' && this.phone != null){
      nul3 = `"phone": "${this.phone}",`;
    }
    if(this.address != '' && this.address != null){
      nul4 = `"address": "${this.address.replace(/\r?\n|\r/g, " ")}",`;
    }

    return `{
      "data":{
        "type": "client",
        "id": "${this.id}",
        "attributes": {`+
          nul1+`
          "name": "${this.name}",
          `+nul2+`
          `+nul4+`
          "contact": "${this.contact}",
          `+nul3+`
          "country_id": "${this.country}"
        }
      }
    }`;

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Client.ts